export const PORTFOLIO_CHART_TYPES = [
  {
    key: 0,
    name: "All",
  },
  {
    key: 1,
    name: "Spot",
  },
  {
    key: 2,
    name: "Margin",
  },
];

export const PORTFOLIO_TYPES = {
  trade: {
    key: 0,
    name: "Portfolio Trade",
  },
  investment: {
    key: 1,
    name: "Portfolio Investment",
  },
};

export const PORTFOLIO_TRADE_TABLE_HEADERS = [
  {
    key: "valueBalance",
    align: "left",
    name: "Value Balance",
  },
  {
    key: "averageBuy",
    align: "left",
    name: "Average Buy",
  },
  {
    key: "averageSell",
    align: "left",
    name: "Average Sell",
  },
  {
    key: "marketPrice",
    align: "left",
    name: "Market Price",
  },
];

export const PORTFOLIO_INVESTMENT_TABLE_HEADERS = [
  {
    key: "valueBalance",
    align: "left",
    name: "Value Balance",
  },
  {
    key: "inventory",
    align: "left",
    name: "Inventory at the start of the report",
  },
  {
    key: "depositWithdraw",
    align: "left",
    name: "Deposit & Withdraw",
  },
  {
    key: "inventoryAvailableNow",
    align: "left",
    name: "Inventory Available Now",
  },
];
